import { render, staticRenderFns } from "./OrthoStageDialog.vue?vue&type=template&id=35f15d38&scoped=true&"
import script from "./OrthoStageDialog.vue?vue&type=script&lang=js&"
export * from "./OrthoStageDialog.vue?vue&type=script&lang=js&"
import style0 from "./OrthoStageDialog.vue?vue&type=style&index=0&id=35f15d38&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f15d38",
  null
  
)

export default component.exports